import { startCase } from 'es-toolkit';

import { Load, ModelCategory } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

import { ModelSchema } from '../ModelSchema';
import { LoadSchema } from './LoadSchema';
import { getLoadTypeOption } from './loadTypeOptions';

interface MutableLoadGroup {
  name: string;
  loadCaseGuid: string;
  loads: ReadonlyArray<Load>;
  id: string;
}
export type LoadGroup = Readonly<MutableLoadGroup>;

export const getLoadGroupName = (load: Load) =>
  `${getLoadTypeOption(load.loadType).name} ${startCase(load.memberType)}`;

export const getLoadGroupId = (loadCaseGuid: string, loadGroupType: string) =>
  `${loadCaseGuid}-loadGroup${loadGroupType}`;

export const LoadGroupSchema = new ModelSchema<LoadGroup>('loadGroup', {
  category: ModelCategory.ComponentDesignData,

  children: {
    loads: LoadSchema,
  },

  properties: {},

  displayName: (loadGroup) => humanCase(loadGroup.name),
});
